export function initFloatingContactBtn() {
    if (window.innerWidth > 766) {
        return;
    }

    const element = document.querySelector('.floating-contact-btn');
    if (!element) {
        return;
    }

    const thresholdAttr = Number(element.getAttribute('data-threshold'));
    const threshold = (Number.isFinite(thresholdAttr) && thresholdAttr > 0 ? thresholdAttr : 50) / 100;

    element.style.position = 'fixed';
    element.style.left = '0';
    element.style.right = '0';
    element.style.bottom = '0';
    element.style.display = 'block';
    element.style.transform = 'translateY(100%)';
    element.style.transition = 'transform 250ms ease';
    element.style.willChange = 'transform';

    let isVisible = false;
    const toggleVisibility = (show) => {
        if (show === isVisible) {
            return;
        }

        isVisible = show;
        element.style.transform = show ? 'translateY(0)' : 'translateY(100%)';
    };

    const onScroll = () => {
        const scrollAmt = window.scrollY || document.documentElement.scrollTop;
        const shouldShow = scrollAmt > (document.documentElement.scrollHeight * threshold);
        toggleVisibility(shouldShow);
    };

    onScroll();
    document.addEventListener('scroll', onScroll, { passive: true });
}
